<template>
  <toggle
    v-model="toggleValue"
    :active-text="translatedActiveText"
    :inactive-text="translatedInactiveText"
    :disabled="disabled"
    :data-qa="dataQa"
    :active-value="activeValue"
    :inactive-value="inactiveValue"
    @change="$emit('change', $event)"
  />
</template>

<script>
import Toggle from '@/common/components/form/Toggle'
export default {
  name: 'FeatureToggle',
  components: { Toggle },
  props: {
    value: {
      required: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    dataQa: {
      type: String,
      required: false
    },
    activeText: {
      type: String,
      required: false
    },
    inactiveText: {
      type: String,
      required: false
    },
    activeValue: {
      type: [Boolean, String, Number],
      default: 1
    },
    inactiveValue: {
      type: [Boolean, String, Number],
      default: 0
    }
  },
  computed: {
    toggleValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    translatedActiveText() {
      return this.activeText
        ? this.$t(this.activeText)
        : this.$t('FeatureToggle_Enabled')
    },
    translatedInactiveText() {
      return this.inactiveText
        ? this.$t(this.inactiveText)
        : this.$t('FeatureToggle_Disabled')
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/common/components/form/FeatureToggle.vue